import { Route } from "@angular/router";
import { AuthGuard } from "../guards/auth.guard";
import { OperationsGuard } from "../guards/operations.guard";

export const AnnouncementsRoutes: Route[] = [
  {
    path: "announcements",
    loadComponent: () =>
      import("../../Feature/announcements/pages/announcements/announcements.component").then(
        (mod) => mod.AnnouncementsComponent
      ),
    pathMatch: "full",
    canActivate: [AuthGuard, OperationsGuard],
  },
];
